import { render, staticRenderFns } from "./TagModal.vue?vue&type=template&id=e5d4e46c&scoped=true"
import script from "./TagModal.vue?vue&type=script&lang=js"
export * from "./TagModal.vue?vue&type=script&lang=js"
import style0 from "./TagModal.vue?vue&type=style&index=0&id=e5d4e46c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d4e46c",
  null
  
)

export default component.exports